import axios from 'axios';
import { useAuthStore } from './auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL + '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // Get token from zustand store
    const { accessToken } = useAuthStore.getState();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    
    // Remove Content-Type for FormData (browser sets it automatically with boundary)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Don't try to refresh if session is locked (tokens intentionally cleared)
      const lockState = localStorage.getItem('oms_idle_lock');
      if (lockState) {
        return Promise.reject(error);
      }
      // Try to refresh token
      const refreshed = await useAuthStore.getState().refreshAccessToken();
      if (refreshed) {
        // Retry the original request with new token
        error.config.headers.Authorization = `Bearer ${useAuthStore.getState().accessToken}`;
        return axios(error.config);
      } else {
        // Clear auth state on unauthorized
        useAuthStore.getState().logout();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
